import { convertToUnderscore } from "./convertToUnderscore";

const dictionary = {
    configuracoes: 'configurações',
    usuarios: 'usuários',
    gerenciar_usuarios: 'Gerenciar Usuários',
    editar_usuario: 'Editar Usuário'
};

export function fieldLabelTransform(key) {
    const underscoredKey = convertToUnderscore(key);
    return dictionary[underscoredKey];
}
